<script setup lang="ts">
import { FormPartProps, useFormPartComposable } from '@src/form/composables/form-part-composable.ts';
import { ModelValuePropsInterface, useModelValueComposable } from '@components/form/compsables/model-value-composable.ts';
import ButtonSquare from '@components/buttons/button-square.vue';
import { TooltipProps } from '@components/tooltip-props.ts';
import { useAttrs } from 'vue';
import { useFocusComposable } from '@components/form/compsables/focus-composable.ts';
import SourceInput from '@components/form/input-base-components/source-input.vue';

const { tooltip, icon, fixed } = defineProps<
    FormPartProps &
    ModelValuePropsInterface &
    {
        tooltip?: TooltipProps,
        icon: string,
        fixed?: boolean
    }
>();

const { modelValue, exposes: modelValueExposes } = useModelValueComposable<string|null>();

const { exposes: formPartExposes, validationMessage, submit } = useFormPartComposable(modelValue);

const { setInput, focus, isFocused, exposes: focusExposes } = useFocusComposable();

defineExpose({ ...modelValueExposes, ...formPartExposes, ...focusExposes });
const attrs = useAttrs();
</script>

<template>
    <div>
        <ButtonSquare
            :tooltip="tooltip"
            :context="isFocused ? 'primary-solid' : 'default'"
            :class="fixed ? $style.fixed : $style.floating"
            :icon="icon"
            @click="focus"
        />
        <SourceInput
            :ref="setInput"
            v-bind="attrs"
            v-model="modelValue"
            hidden
            scanner
            :validation-message="validationMessage"
            :form="form"
            :name="name"
            @submit="submit"
        />
    </div>
</template>

<style lang="scss" module>
    .fixed {
        position: fixed;
        top: 0;
        right: 0;
        z-index: 1;
        font-size: 1.3em;
        background-color: #fff;
    }
    .floating {
        height: 100%;
    }
</style>
